import { GestionCoStatus } from '@greenkub-fronts/shared/interface'

export interface ICategorieCommerciale {
  slug: string;
  value: string;
  color: string;
  count: number;
}

export const projectStateGestionCommerciale: ICategorieCommerciale[] = [
  {
    slug: GestionCoStatus.A_TRIER,
    value: 'À trier',
    color: '#e1adf0',
    count: 0,
  },
  {
    slug: GestionCoStatus.WC_NON_VALIDE,
    value: 'WC non validé',
    color: '#FF8C00',
    count: 0,
  },
  {
    slug: GestionCoStatus.DOSSIER_MAIRIE_EN_PREVISION,
    value: 'Dossiers mairie en prévision',
    color: '#32CD32',
    count: 0,
  },
  {
    slug: GestionCoStatus.PM_A_FAIRE,
    value: 'PM à faire',
    color: '#3CB371',
    count: 0,
  },
  {
    slug: GestionCoStatus.PM_EN_ATTENTE_DE_VALIDATION,
    value: 'PM en attente de validation',
    color: '#00BFFF',
    count: 0,
  },
  {
    slug: GestionCoStatus.DOSSIER_MAIRIE_A_FAIRE,
    value: 'Dossier mairie à faire',
    color: '#0000FF',
    count: 0,
  },
  {
    slug: GestionCoStatus.DOSSIER_COMPLETS_SOUS_PLI,
    value: 'Dossiers complets sous pli',
    color: '#00008B',
    count: 0,
  },
  {
    slug: GestionCoStatus.EN_MAIRIE_SANS_MDG,
    value: 'En mairie sans MDG',
    color: '#FF00FF',
    count: 0,
  },
  {
    slug: GestionCoStatus.EN_MAIRIE,
    value: 'En mairie',
    color: '#c13ce6',
    count: 0,
  },
  {
    slug: GestionCoStatus.ACCORD_MAIRIE,
    value: 'Accord mairie',
    color: '#9402bd',
    count: 0,
  },
  {
    slug: GestionCoStatus.PIECE_COMP_A_FAIRE,
    value: 'Pièces comp. à faire',
    color: '#F5DEB3',
    count: 0,
  },
  {
    slug: GestionCoStatus.PIECES_COMP_RECUES,
    value: 'Pièces comp. reçues',
    color: '#fac86b',
    count: 0,
  },
  {
    slug: GestionCoStatus.PIECE_COMP_RENVOYES_EN_MAIRIE,
    value: 'Pièces comp. renvoyées en mairie',
    color: '#fab025',
    count: 0,
  },
  {
    slug: GestionCoStatus.REFUS_RECUS,
    value: 'Refus reçus',
    color: '#FF7F50',
    count: 0,
  },
  {
    slug: GestionCoStatus.REDEPOT_A_FAIRE,
    value: 'Redépôt à faire',
    color: '#FF6347',
    count: 0,
  },
  {
    slug: GestionCoStatus.REFUS_RENVOYER_EN_MAIRIE,
    value: 'Refus renvoyé en mairie',
    color: '#FF6347',
    count: 0,
  },
  {
    slug: GestionCoStatus.OPPOSITION,
    value: 'Opposition',
    color: '#BB0B0B',
    count: 0,
  },
  {
    slug: GestionCoStatus.DOSSIER_EN_ATTENTE,
    value: 'Dossier en attente',
    color: '#F0FFFF',
    count: 0,
  },
  {
    slug: GestionCoStatus.ANNULATION_CLIENT,
    value: 'Annulation client',
    color: '#C0C0C0',
    count: 0,
  },
  {
    slug: GestionCoStatus.ANNULATION_PLU,
    value: 'Annulation PLU',
    color: '#A9A9A9',
    count: 0,
  },
  {
    slug: GestionCoStatus.ANNULATION_REFUS_MAIRIE,
    value: 'Annulation refus mairie',
    color: '#808080',
    count: 0,
  },
  {
    slug: GestionCoStatus.SANS_DP_50,
    value: 'Sans DP 50%',
    color: '#40E0D0',
    count: 0,
  },
  {
    slug: GestionCoStatus.TERMINE,
    value: 'Terminé',
    color: '#FFC0CB',
    count: 0,
  },
]
